import { Injectable } from "@angular/core";
import { SubjectsService } from "@carnegie-learning/data-access-angular-cure";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import * as studentActiveSubjectsActions from "../actions/student-active-subjects.action";

@Injectable()
export class StudentActiveSubjectsEffects {
    constructor(
        private actions$: Actions,
        private subjectsService: SubjectsService
    ) {}

    loadStudentActiveSubjects$ = createEffect(() =>
        this.actions$
            .pipe(ofType(studentActiveSubjectsActions.LoadStudentActiveSubjects))
            .pipe(
                switchMap(action => {
                    return this.subjectsService.getActiveSubjects().pipe(
                        map(subjects => subjects),
                        map(subjects =>
                            studentActiveSubjectsActions.LoadStudentActiveSubjectsSuccess({
                                payload: subjects
                            })
                        ),
                        catchError(error =>
                            of(
                                studentActiveSubjectsActions.LoadStudentActiveSubjectsFail({
                                    payload: error
                                })
                            )
                        )
                    );
                })
            )
    );
}
